import React, { Fragment, useEffect, useState } from "react";
import {
  Tabs,
  Select,
  Descriptions,
  Form,
  Input,
  Modal,
  Spin,
  Alert,
  Tooltip,
  Popconfirm,
  Button,
  Empty,
  Row,
  Col,
} from "antd";
import styles from "../topology.module.scss";
import { FcSynchronize } from "react-icons/fc";
import { AiOutlineSync } from "react-icons/ai";

import service from "Utility/Service";
import { TimestampToDate } from "../../../Utility/Fetch";
import { useTranslation } from "react-i18next";
import { setDeviceRecord, setIoTVisible } from "../store/topologySlice";
import { useAppSelector, useAppDispatch } from "store/hook";
import { setIsLogin } from "../../store/globalSlice";
import { AxiosRequestConfig } from "axios";
import { useLogout } from "Components/Login/quires";
interface IIoTDeviceList {
  id: string;
  name: string;
  timestamp: number;
}

const { TabPane } = Tabs;
const { Option } = Select;

const setIoTForm = (form: any, IoTData: any) => {
  let EEPROME = IoTData.eeprom;
  form.setFieldsValue({
    battery_capacity_ah: EEPROME.battery_capacity_ah,
    battery_type: EEPROME.battery_type,
    charge_limit_voltage_v: EEPROME.charge_limit_voltage_v,
    discharge_limit_voltage_v: EEPROME.discharge_limit_voltage_v,
    equalizing_charge_interval_day: EEPROME.equalizing_charge_interval_day,
    equalizing_charge_time_min: EEPROME.equalizing_charge_time_min,
    equalizing_charge_voltage_v: EEPROME.equalizing_charge_voltage_v,
    folating_charge_voltage_v: EEPROME.folating_charge_voltage_v,
    low_voltage_warning_voltage_v: EEPROME.low_voltage_warning_voltage_v,
    over_discharge_delay_s: EEPROME.over_discharge_delay_s,
    over_discharge_reverse_voltage_v: EEPROME.over_discharge_reverse_voltage_v,
    over_discharge_voltage_v: EEPROME.over_discharge_voltage_v,
    overvoltage_voltage_v: EEPROME.overvoltage_voltage_v,
    rasing_charge_reverse_voltage_v: EEPROME.rasing_charge_reverse_voltage_v,
    rasing_charge_time_min: EEPROME.rasing_charge_time_min,
    rasing_charge_voltage_v: EEPROME.rasing_charge_voltage_v,
    recognized_voltage_v: EEPROME.recognized_voltage_v,
    system_voltage_v: EEPROME.system_voltage_v,
    temperature_coefficient: EEPROME.temperature_coefficient,
  });
};

const layout = {
  labelCol: { span: 9 },
  wrapperCol: { span: 11 },
};

const IoTModal = React.memo(() => {
  const [uploading, setUploading] = useState(false);
  const [form] = Form.useForm();
  const [IoTData, setIoTData] = useState<any>(undefined);
  const [IoTDeviceList, setIoTDeviceList] = useState<IIoTDeviceList[]>([]);
  const [Refresh, setRefresh] = useState(false);
  const [tabKey, setTabKey] = useState("1");
  const [haveContent, setHaveContent] = useState(false);
  const [Deviceindex, setDeviceindex] = useState(0);
  const Editable = false;
  const { t } = useTranslation();
  const disp = useAppDispatch();
  const { deviceRecord, IoTVisible } = useAppSelector((state) => state.topology);
  const { isLogin, time_zone } = useAppSelector((state) => state.global);
  const { mutate: logoutMutation } = useLogout();

  const handleDeviceChange = (value: number) => {
    setDeviceindex(value);
  };

  useEffect(() => {
    if (deviceRecord?.id) {
      // console.log('執行這裡')
      setUploading(true);
      const IoTUrl = Refresh
        ? { get: { device_cfg: { filter: { id: deviceRecord.id }, nodeInf: {}, obj: { iot: {} } } } }
        : { get: { device_iot: { filter: { id: deviceRecord.id } } } };

      const config: AxiosRequestConfig = {
        method: "post",
        headers: { "Content-Type": "application/json" },
        url: "/cmd",
        data: IoTUrl,
      };

      service(config)
        .then((res) => {
          if (!Refresh && res.data.response.device_iot?.[0]?.obj?.iot) {
            const IoTArray = res.data.response.device_iot[0].obj.iot;
            const IoTData = IoTArray?.[Deviceindex]?.data;
            setHaveContent(true);
            setIoTData(IoTData);
            setIoTDeviceList(IoTArray);

            IoTArray.forEach((item: any) => {
              item.timestamp = TimestampToDate(item.timestamp * 1000, time_zone, true);
            });

            setIoTForm(form, IoTData);
          } else if (Refresh && res.data.response.device_cfg?.[0]?.obj?.iot) {
            const IoTArray = res.data.response.device_cfg[0].obj.iot;
            const IoTData = IoTArray[Deviceindex].data;
            setHaveContent(true);
            setIoTData(IoTData);

            IoTArray.forEach((item: any) => {
              item.timestamp = TimestampToDate(item.timestamp * 1000, time_zone, true);
            });
            setIoTDeviceList(IoTArray);
            setIoTForm(form, IoTData);
          } else {
            setHaveContent(false);
          }

          setUploading(false);
        })
        .catch((error) => {
          console.log(error);
          setUploading(false);
          if (error.response?.status === 401) {
            disp(setIsLogin(!isLogin));
            logoutMutation();
          }
        });

      setRefresh(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [IoTVisible === true, Refresh, Deviceindex]);

  return (
    <Modal
      visible={IoTVisible}
      onCancel={() => {
        disp(setIoTVisible(false));
        setIoTData(undefined);
        setRefresh(false);
        disp(setDeviceRecord({ id: null }));
        setHaveContent(false);
        setTabKey("1");
        setDeviceindex(0);
      }}
      centered={true}
      destroyOnClose={true}
      className={styles.modal}
      footer={[
        <Button
          key="confirm"
          type="primary"
          onClick={() => {
            disp(setIoTVisible(false));
            setIoTData(undefined);
            setRefresh(false);
            disp(setDeviceRecord({ id: null }));
            setHaveContent(false);
            setTabKey("1");
          }}
        >
          {t("ISMS.Confirm")}
        </Button>,
      ]}
    >
      {IoTData && !uploading ? (
        <Fragment>
          <Select
            defaultValue={Deviceindex}
            className={styles.FourEightFiveBar}
            onChange={(value) => {
              handleDeviceChange(value);
            }}
          >
            {IoTDeviceList?.map((item: { id: string; name: string }, index: number) => {
              return (
                <Option key={index} value={index}>
                  {item.id} ({item.name})
                </Option>
              );
            })}
          </Select>

          <div style={{ display: "flex", marginBottom: "10px" }}>
            <p>
              {t("ISMS.Date")}: {IoTDeviceList[Deviceindex].timestamp}
            </p>
            {/* <Tooltip title={t("ISMS.Refresh Data")}>
              <Popconfirm
                title={t("ISMS.Sure to refresh?")}
                okText={t("ISMS.OK")}
                cancelText={t("ISMS.Cancel")}
                onConfirm={() => {
                  setRefresh(true);
                  setHaveContent(false);
                }}
              >
                <FcSynchronize className={styles.Refresh} />
              </Popconfirm>
            </Tooltip> */}

            <Tooltip title={""}>
              <AiOutlineSync
                className={styles.Refresh}
                onClick={() => {
                  setRefresh(true);
                  setHaveContent(false);
                }}
              />
            </Tooltip>
          </div>

          <Row gutter={24}>
            <Col xs={24} sm={24} md={24} lg={24}>
              {t("ISMS.Data")}: {!JSON.stringify(IoTData) ? "null" : JSON.stringify(IoTData)}
            </Col>
          </Row>

          {/* <Tabs
            defaultActiveKey={tabKey}
            onChange={(activeKey) => {
              setTabKey(activeKey);
            }}
          > */}
          {/* <TabPane tab="Today" key="1" className={styles.tabpane}>
            <Descriptions className={styles.desc} column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}>
              {Object.entries(IoTData).map((item: any, idx: number) => {
                let measurement;
                switch (item[0]) {
                  case "Temperature":
                    measurement = "℃";
                    break;
                  case "Humidity":
                    measurement = "%";
                    break;
                  case "pH":
                    measurement = "";
                    break;
                  case "Voltage":
                    measurement = "VDC";
                    break;
                  case "Fan_Speed":
                    measurement = "RPM";
                    break;
                  default:
                    measurement = "";
                }

                return (
                  <>
                    <Descriptions.Item label={`${item[0]}`}>
                      {`${JSON.stringify(item[1])} ${measurement}`}
                    </Descriptions.Item>
                  </>
                );
              })}
            </Descriptions>
            </TabPane> */}

          {/* ==================== customized for Kind Solomen ==================== */}
          {/* <TabPane tab="Today" key="1" className={styles.tabpane}>
              <Descriptions bordered column={{ xxl: 3, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }} className={styles.desc}>
                <Descriptions.Item label="Battery Minimal Voltage" className={styles.descItem}>
                  {IoTData.controller?.today?.battery?.min_voltage_v}
                  (V)
                </Descriptions.Item>
                <Descriptions.Item label="Battery Maximum Voltage" className={styles.descItem}>
                  {IoTData.controller?.today?.battery?.max_voltage_v}
                  (V)
                </Descriptions.Item>
                <Descriptions.Item label="Charge Maximum Current" className={styles.descItem}>
                  {IoTData.controller?.today?.charge?.max_current_a}
                  (A)
                </Descriptions.Item>
                <Descriptions.Item label="Charge AH" className={styles.descItem}>
                  {IoTData.controller?.today?.charge?.ampere_hour_ah}
                  (A/H)
                </Descriptions.Item>
                <Descriptions.Item label="Charge Watt" className={styles.descItem}>
                  {IoTData.controller?.today?.charge?.watt_w}(W)
                </Descriptions.Item>
                <Descriptions.Item label="Charge Maximum Watt" className={styles.descItem}>
                  {IoTData.controller?.today?.charge?.max_watt_w}(W)
                </Descriptions.Item>
                <Descriptions.Item label="Charge Total Watt" className={styles.descItem}>
                  {IoTData.controller?.today?.charge?.total_watt_w}(W)
                </Descriptions.Item>
                <Descriptions.Item label="Discharge Maximum Current" className={styles.descItem}>
                  {IoTData.controller?.today?.discharge?.max_current_a}
                  (A)
                </Descriptions.Item>
                <Descriptions.Item label="Discharge AH" className={styles.descItem}>
                  {IoTData.controller?.today?.discharge?.ampere_hour_ah}
                  (A/H)
                </Descriptions.Item>
                <Descriptions.Item label="Discharge Watt" className={styles.descItem}>
                  {IoTData.controller?.today?.discharge?.watt_w}
                  (W)
                </Descriptions.Item>
                <Descriptions.Item label="Discharge Maximum Watt" className={styles.descItem}>
                  {IoTData.controller?.today?.discharge?.max_watt_w}
                  (W)
                </Descriptions.Item>
                <Descriptions.Item label="Discharge Total Watt" className={styles.descItem}>
                  {IoTData.controller?.today?.discharge?.total_watt_w}
                  (W)
                </Descriptions.Item>
              </Descriptions>
            </TabPane>
            <TabPane tab="Solar Pannel" key="2" className={styles.tabpane}>
              <Descriptions bordered className={styles.desc} column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}>
                <Descriptions.Item label="Current">{IoTData.controller?.solar_pannel?.current_a} (A)</Descriptions.Item>
                <Descriptions.Item label="Voltage">{IoTData.controller?.solar_pannel?.voltage_v} (V)</Descriptions.Item>
                <Descriptions.Item label="Watt">{IoTData.controller?.solar_pannel?.watt_w} (W)</Descriptions.Item>
                <Descriptions.Item label="Temperature">
                  {IoTData.controller?.temperature_c}
                  (C)
                </Descriptions.Item>
              </Descriptions>
            </TabPane>
            <TabPane tab="Battery" key="3" className={styles.tabpane}>
              <Descriptions bordered className={styles.desc}>
                <Descriptions.Item label="Charge Current">
                  {IoTData.controller?.battery?.charge_current_a} (A)
                </Descriptions.Item>
                <Descriptions.Item label="Full Charged Time">
                  {IoTData.controller?.battery?.full_charged_time}
                </Descriptions.Item>
                <Descriptions.Item label="Over Discharged Time">
                  {IoTData.controller?.battery?.over_discharged_time}
                </Descriptions.Item>
                <Descriptions.Item label="SOC">{IoTData.controller?.battery?.soc_percentage} (%)</Descriptions.Item>
                <Descriptions.Item label="Temperature">
                  {IoTData.controller?.battery?.temperature_c} (C)
                </Descriptions.Item>
                <Descriptions.Item label="Total Charge">
                  {IoTData.controller?.battery?.total_charge_ah}
                  (A/H)
                </Descriptions.Item>
                <Descriptions.Item label="Total Discharge">
                  {IoTData.controller?.battery?.total_discharge_ah}
                  (A/H)
                </Descriptions.Item>
                <Descriptions.Item label="Voltage">{IoTData.controller?.battery?.voltage_v} (V)</Descriptions.Item>
                <Descriptions.Item label="Charge State">{IoTData.controller?.charge_state}</Descriptions.Item>
              </Descriptions>
            </TabPane>
            <TabPane tab="Load" key="4" className={styles.tabpane}>
              <Descriptions bordered className={styles.desc} column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}>
                <Descriptions.Item label="Current">{IoTData.controller?.load.current_a} (A)</Descriptions.Item>
                <Descriptions.Item label="Voltage">{IoTData.controller?.load.voltage_v} (V)</Descriptions.Item>
                <Descriptions.Item label="Watt">{IoTData.controller?.load.watt_w} (W)</Descriptions.Item>
                <Descriptions.Item label="Load Light">
                  {IoTData.controller?.load_light_percentage}
                  (%)
                </Descriptions.Item>
                <Descriptions.Item label="Load ON/OFF">{IoTData.controller?.load_on_off}</Descriptions.Item>
              </Descriptions>
            </TabPane>
            <TabPane tab="EEProm" key="5" className={styles.tabpane}>
              <Form {...layout} form={form}>
                <Descriptions bordered className={styles.desc} column={{ xxl: 3, xl: 2, lg: 2, md: 2, sm: 2, xs: 1 }}>
                  <Descriptions.Item label="Battery Capacity">
                    {Editable ? (
                      <Form.Item name="battery_capacity_ah">
                        <Input className={styles.IoTinput} disabled={true} />
                      </Form.Item>
                    ) : (
                      IoTData.eeprom?.battery_capacity_ah
                    )}{" "}
                    (AH)
                  </Descriptions.Item>
                  <Descriptions.Item label="Battery Type">
                    {Editable ? (
                      <Form.Item name="battery_type">
                        <Input className={styles.IoTinput} disabled={true} />
                      </Form.Item>
                    ) : (
                      IoTData.eeprom?.battery_type
                    )}
                  </Descriptions.Item>

                  <Descriptions.Item label="Charge Limit">
                    {Editable ? (
                      <Form.Item name="charge_limit_voltage_v">
                        <Input className={styles.IoTinput} disabled={true} />
                      </Form.Item>
                    ) : (
                      IoTData.eeprom?.charge_limit_voltage_v
                    )}{" "}
                    (V)
                  </Descriptions.Item>

                  <Descriptions.Item label="Discharge Limit">
                    {Editable ? (
                      <Form.Item name="discharge_limit_voltage_v">
                        <Input className={styles.IoTinput} disabled={true} />
                      </Form.Item>
                    ) : (
                      IoTData.eeprom?.discharge_limit_voltage_v
                    )}{" "}
                    (V)
                  </Descriptions.Item>

                  <Descriptions.Item label="Equalizing Charge Interval">
                    {Editable ? (
                      <Form.Item name="equalizing_charge_interval_day">
                        <Input className={styles.IoTinput} disabled={true} />
                      </Form.Item>
                    ) : (
                      IoTData.eeprom?.equalizing_charge_interval_day
                    )}{" "}
                    (day)
                  </Descriptions.Item>

                  <Descriptions.Item label="Equalizing Charge time">
                    {Editable ? (
                      <Form.Item name="equalizing_charge_time_min">
                        <Input className={styles.IoTinput} disabled={true} />
                      </Form.Item>
                    ) : (
                      IoTData.eeprom?.equalizing_charge_time_min
                    )}{" "}
                    (min)
                  </Descriptions.Item>

                  <Descriptions.Item label="Equalizing Charge">
                    {Editable ? (
                      <Form.Item name="equalizing_charge_voltage_v">
                        <Input className={styles.IoTinput} disabled={true} />
                      </Form.Item>
                    ) : (
                      IoTData.eeprom?.equalizing_charge_voltage_v
                    )}{" "}
                    (V)
                  </Descriptions.Item>

                  <Descriptions.Item label="Folating Charge">
                    {Editable ? (
                      <Form.Item name="folating_charge_voltage_v">
                        <Input className={styles.IoTinput} disabled={true} />
                      </Form.Item>
                    ) : (
                      IoTData.eeprom?.folating_charge_voltage_v
                    )}{" "}
                    (V)
                  </Descriptions.Item>

                  <Descriptions.Item label="Low Voltage Warning">
                    {Editable ? (
                      <Form.Item name="low_voltage_warning_voltage_v">
                        <Input className={styles.IoTinput} disabled={true} />
                      </Form.Item>
                    ) : (
                      IoTData.eeprom?.low_voltage_warning_voltage_v
                    )}{" "}
                    (V)
                  </Descriptions.Item>

                  <Descriptions.Item label="Over Discharge Delay">
                    {Editable ? (
                      <Form.Item name="over_discharge_delay_s">
                        <Input className={styles.IoTinput} disabled={true} />
                      </Form.Item>
                    ) : (
                      IoTData.eeprom?.over_discharge_delay_s
                    )}{" "}
                    (s)
                  </Descriptions.Item>
                  <Descriptions.Item label="Over Discharge Reverse">
                    {Editable ? (
                      <Form.Item name="over_discharge_reverse_voltage_v">
                        <Input className={styles.IoTinput} disabled={true} />
                      </Form.Item>
                    ) : (
                      IoTData.eeprom?.over_discharge_reverse_voltage_v
                    )}{" "}
                    (V)
                  </Descriptions.Item>

                  <Descriptions.Item label="Over Discharge">
                    {Editable ? (
                      <Form.Item name="over_discharge_voltage_v">
                        <Input className={styles.IoTinput} disabled={true} />
                      </Form.Item>
                    ) : (
                      IoTData.eeprom?.over_discharge_voltage_v
                    )}{" "}
                    (V)
                  </Descriptions.Item>

                  <Descriptions.Item label="Overvoltage">
                    {Editable ? (
                      <Form.Item name="overvoltage_voltage_v">
                        <Input className={styles.IoTinput} disabled={true} />
                      </Form.Item>
                    ) : (
                      IoTData.eeprom?.overvoltage_voltage_v
                    )}{" "}
                    (V)
                  </Descriptions.Item>

                  <Descriptions.Item label="Rasing Charge Reverse Voltage">
                    {Editable ? (
                      <Form.Item name="rasing_charge_reverse_voltage_v">
                        <Input className={styles.IoTinput} disabled={true} />
                      </Form.Item>
                    ) : (
                      IoTData.eeprom?.rasing_charge_reverse_voltage_v
                    )}{" "}
                    (V)
                  </Descriptions.Item>

                  <Descriptions.Item label="Rasing Charge Time">
                    {Editable ? (
                      <Form.Item name="rasing_charge_time_min">
                        <Input className={styles.IoTinput} disabled={true} />
                      </Form.Item>
                    ) : (
                      IoTData.eeprom?.rasing_charge_time_min
                    )}{" "}
                    (min)
                  </Descriptions.Item>

                  <Descriptions.Item label="Rasing Charge">
                    {Editable ? (
                      <Form.Item name="rasing_charge_voltage_v">
                        <Input className={styles.IoTinput} disabled={true} />
                      </Form.Item>
                    ) : (
                      IoTData.eeprom?.rasing_charge_voltage_v
                    )}{" "}
                    (V)
                  </Descriptions.Item>

                  <Descriptions.Item label="Recognized Voltage">
                    {Editable ? (
                      <Form.Item name="recognized_voltage_v">
                        <Input className={styles.IoTinput} disabled={true} />
                      </Form.Item>
                    ) : (
                      IoTData.eeprom?.recognized_voltage_v
                    )}{" "}
                    (V)
                  </Descriptions.Item>

                  <Descriptions.Item label="System Voltage">
                    {Editable ? (
                      <Form.Item name="system_voltage_v">
                        <Input className={styles.IoTinput} disabled={true} />
                      </Form.Item>
                    ) : (
                      IoTData.eeprom?.system_voltage_v
                    )}{" "}
                    (V)
                  </Descriptions.Item>

                  <Descriptions.Item label="Temp Coefficient">
                    {Editable ? (
                      <Form.Item name="temperature_coefficient">
                        <Input className={styles.IoTinput} disabled={true} />
                      </Form.Item>
                    ) : (
                      IoTData.eeprom?.temperature_coefficient
                    )}
                  </Descriptions.Item>
                </Descriptions>
              </Form>
            </TabPane>
            <TabPane tab="System" key="6" className={styles.tabpane}>
              <Descriptions bordered className={styles.desc} column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}>
                <Descriptions.Item label="Charge Current">{IoTData.system?.charge_current_a} (A)</Descriptions.Item>
                <Descriptions.Item label="Discharge Current">
                  {IoTData.system?.discharge_current_a} (A)
                </Descriptions.Item>
                <Descriptions.Item label="Voltage Max">{IoTData.system?.max_voltage_v} (V)</Descriptions.Item>
                <Descriptions.Item label="Hardware Version">{IoTData.system?.hardware_version}</Descriptions.Item>
                <Descriptions.Item label="Serial Number">{IoTData.system?.serial_number}</Descriptions.Item>
                <Descriptions.Item label="Software Version">{IoTData.system?.software_version}</Descriptions.Item>
              </Descriptions>
            </TabPane>
            <TabPane tab="PLC" key="7" className={styles.tabpane}>
              <Descriptions bordered className={styles.desc} column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}>
                {Object.entries(IoTData).map((item: any, idx: number) => {
                  return (
                    <>
                      <Descriptions.Item label={`${item[0]}`}>{JSON.stringify(item[1])}</Descriptions.Item>
                    </>
                  );
                })}
              </Descriptions>
            </TabPane> */}
          {/* ==================== customized for Kind Solomen END ==================== */}
          {/* </Tabs> */}
        </Fragment>
      ) : uploading ? (
        <Spin tip="Loading...">
          <Alert
            message="Getting Data"
            description="We are now getting data from server, please wait for a few seconds"
          />
        </Spin>
      ) : (
        <>
          {IoTDeviceList?.length > 1 ? (
            <Select
              defaultValue={Deviceindex}
              className={styles.FourEightFiveBar}
              onChange={(value) => {
                handleDeviceChange(value);
              }}
            >
              {IoTDeviceList?.map((item: { id: string; name: string }, index: number) => {
                return (
                  <Option key={index} value={index}>
                    {item.id} ({item.name})
                  </Option>
                );
              })}
            </Select>
          ) : (
            <Select
              // defaultValue={}
              className={styles.FourEightFiveBar}
              onChange={(value) => {
                handleDeviceChange(value);
              }}
            />
          )}

          <Empty description={<span>No Data</span>} />
        </>
      )}
    </Modal>
  );
});

export default IoTModal;
